window.okeReviewsWidgetOnInit = function () {
  // replace based on x reviews with x reviews
  const xReviews = document.querySelector(".okeReviews-reviews-controls-reviewCount");
  const basedOnXReviews = document.querySelector(".okeReviews-reviewsAggregate-summary-total");
  if (xReviews && basedOnXReviews) {
      basedOnXReviews.innerHTML = xReviews.innerHTML;
  }

  // move dropdown to aggregate
  const dropdown = document.querySelector(".okeReviews-reviews-controls-select");
  const aggregate = document.querySelector(".okeReviews-reviewsAggregate-primary");
  if (dropdown && aggregate) {
      aggregate.append(dropdown);
  }

  // restructure reviews on change
  restructureIndividualReviews();
  const okeObserver = new MutationObserver(restructureIndividualReviews);
  okeObserver.observe(document.querySelector(".js-okeReviews-reviews-main"), { childList: true });

  // Rename Fit Label
  const fitLabel = document.querySelector(".okeReviews .okeReviews-attributeRatingsTable-row-label");
  $(fitLabel).html("Fit");
};

function restructureIndividualReviews(mutationsList) {
  const nodesToRestructure = mutationsList ? mutationsList[0].addedNodes : document.querySelectorAll(".okeReviews-reviews-review");
  for (let i = 0; i < nodesToRestructure.length; ++i) {
      const reviewNode = nodesToRestructure[i];
      const dateMeta = reviewNode.querySelector(".okeReviews-review-date");
      const reviewer = reviewNode.querySelector(".okeReviews-review-reviewer-profile");
      if (dateMeta && reviewer) {
          reviewer.insertAdjacentElement("afterend", dateMeta);
      }

      // format date
      const dateElement = reviewNode.querySelector("[data-oke-reviews-date]");
      const d = new Date(dateElement.getAttribute("data-oke-reviews-date"));
      const year = new Intl.DateTimeFormat("en", { year: "numeric" }).format(d);
      const month = new Intl.DateTimeFormat("en", { month: "short" }).format(d);
      const day = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(d);
      dateElement.innerText = `${month} ${day}, ${year}`;
  }
}